import axios from "../helpers/axios";
import { API_URL, ROLE, catchHandler, dispatchError, dispatchLoading, dispatchToast, elseHandler } from "../helpers/utils";
const AUTH_URL = `${API_URL}/auth`;

export const LoginAPI = (data, navigate) => async (dispatch) => {
  dispatchLoading(dispatch, "auth", true);
  axios
    .post(`${AUTH_URL}/login`, data)
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "LOGIN_SUCCESS",
          payload: result?.data?.data,
        });
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("token", result?.data?.data?.token);
        let userRole = result?.data?.data?.role;
        if (userRole === ROLE?.ADMIN) {
          navigate("/admin/dashboard");
          dispatchToast(dispatch, "success", "Login Successful");
          dispatchError(dispatch, "auth", undefined);
        } else if (userRole === ROLE?.USER) {
          // dispatchToast(dispatch, "success", );
          dispatchError(dispatch, "auth", "No such user found");
        }
      } else elseHandler(dispatch, "auth", result?.data);
      dispatchLoading(dispatch, "auth", false);
    })
    .catch(catchHandler(dispatch, "auth"));
};

export const ForgotPasswordAPI = (data, setLinkSent, setEmail) => (dispatch) => {
  dispatchLoading(dispatch, "auth", true);

  axios
    .post(`${AUTH_URL}/forgot-password`, data)
    .then((result) => {
      if (result?.data?.success) {
        dispatchToast(dispatch, "success", result?.data?.message);
        dispatchError(dispatch, "auth", undefined);
        setLinkSent(true);
        setEmail(data?.email);
      } else elseHandler(dispatch, "auth", result?.data);
      dispatchLoading(dispatch, "auth", false);
    })
    .catch(catchHandler(dispatch, "auth"));
};

export const GetProfileAPI = (navigate) => async (dispatch) => {
  dispatchLoading(dispatch, "auth", true);
  axios
    .get(`${AUTH_URL}/profile`)
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "AUTH_LOAD_SUCCESS",
          payload: result?.data?.data,
        });
        // navigate("/admin/dashboard");
        dispatchError(dispatch, "auth", undefined);
      } else {
        dispatch({ type: "AUTH_LOAD_FAILURE" });
        elseHandler(dispatch, "auth", result?.data);
      }
      dispatchLoading(dispatch, "auth", false);
    })
    .catch((err) => {
      dispatch({ type: "AUTH_LOAD_FAILURE" });
      dispatchLoading(dispatch, "auth", false);
    });
};

export const LogoutAPI = (data, navigate) => async (dispatch) => {
  dispatchLoading(dispatch, "auth", true);
  axios
    .post(`${AUTH_URL}/logout`, data)
    .then((result) => {
      if (result?.data?.success) {
        dispatchToast(dispatch, "success", result?.data?.message);
        dispatchError(dispatch, "auth", undefined);
        dispatch({ type: "LOGOUT_SUCCESS", payload: null });
        localStorage.setItem("isLoggedIn", false);
        localStorage.removeItem("token");
        setTimeout(() => {
          navigate("/");
        }, 900);
      } else elseHandler(dispatch, "auth", result?.data);
      dispatchLoading(dispatch, "auth", false);
    })
    .catch(catchHandler(dispatch, "auth"));
};

export const ResetPasswordAPI = (data, navigate) => (dispatch) => {
  dispatchLoading(dispatch, "auth", true);
  axios
    .put(`${AUTH_URL}/reset-password`, data)
    .then((result) => {
      if (result?.data?.success) {
        dispatchToast(dispatch, "success", result?.data?.message);
        dispatchError(dispatch, "auth", undefined);
        navigate("/auth/login");
      } else elseHandler(dispatch, "auth", result?.data);
      dispatchLoading(dispatch, "auth", false);
    })
    .catch(catchHandler(dispatch, "auth"));
};

export const UpdateProfileAPI = (data, navigate) => async (dispatch) => {
  dispatchLoading(dispatch, "auth", true);
  axios
    .put(`${AUTH_URL}/profile`, data)
    .then((result) => {
      if (result?.data?.success) {
        dispatch(GetProfileAPI());
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 500);
        dispatchToast(dispatch, "success", result?.data?.message);
        dispatchError(dispatch, "auth", undefined);
      } else elseHandler(dispatch, "auth", result?.data);
      dispatchLoading(dispatch, "auth", false);
    })
    .catch(catchHandler(dispatch, "auth"));
};

export const UpdatePasswordAPI = (data, navigate) => async (dispatch) => {
  dispatchLoading(dispatch, "auth", true);
  axios
    .put(`${AUTH_URL}/change-password`, data)
    .then((result) => {
      if (result?.data?.success) {
        navigate("/admin/dashboard");
        dispatchToast(dispatch, "success", result?.data?.message);
        dispatchError(dispatch, "auth", undefined);
      } else elseHandler(dispatch, "auth", result?.data);
      dispatchLoading(dispatch, "auth", false);
    })
    .catch(catchHandler(dispatch, "auth"));
};
